import { render } from "./TypeSpecimen.vue?vue&type=template&id=e70ba362&scoped=true"
import script from "./TypeSpecimen.vue?vue&type=script&lang=js"
export * from "./TypeSpecimen.vue?vue&type=script&lang=js"

import "./TypeSpecimen.vue?vue&type=style&index=0&id=e70ba362&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70ba362"]])

export default __exports__